// import React from 'react'
// import Footer from '../../../../components/Footer'
// import BtechImg from "../../../../assets/images/engineering.jpeg";
// import { Link } from 'react-router-dom';

// const MtechTransportation = () => {
//   return (
//     <div className='  w-full relative font-poppins ' >
//         <div className=' w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5 ' >
//         <h2 className={` mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38] `}>Master of Technology in Transportation Engineering</h2>
//         <div className=' w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] ' ></div>
//             <div className=' flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between ' >
//                 <img src={BtechImg} className=' md:w-[40%] rounded-lg ' />
//                 <div className=' flex flex-col gap-4 ' >
//                     <h4 className=' font-bold text-xl md:text-3xl ' >About the Department</h4>
//                     <p className=' text-justify md:text-lg ' >Transportation Engineering involves planning, constructing and operating the transportation facilities for different modes of transport i.e., highways, railways, air transport, sea transport, and pipelines. Devising the urban & intermodal transportation in an environment-friendly manner is the prime goal of transportation engineering.
//                     <br/>
//                     <br/>
//                     Transportation Engineering can be broadly classified into:
//                     <ul className=' list-disc ' >
//                     <li>Highway Engineering</li>
//                     <li>Railroad Engineering</li>
//                     <li>Port & Harbour Engineering</li>
//                     <li>Airport Engineering</li>
//                     <li>Urban Engineering</li>
//                     </ul>
//                     The curriculum of M. Tech in Transportation Engineering encompasses topics like Advanced Traffic Engineering, Advanced Railway Engineering, Urban Transport Planning, Ground Improvement Techniques, Airport Planning & Design, Highway Construction, Quality Control & Maintenance, etc.
//                     </p>
//                     <Link to="https://admission.maya.edu.in/" >
//                     <button className=' mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] '
//                     >Register Now</button>
//                 </Link>
//                 </div>
//             </div>

//             <div className=' flex flex-col gap-10 mt-5 mb-[50px] ' >
//                <div className=' flex flex-col gap-2 ' >
//                         <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Eligibility Criteria</h4>
//                         <p>Bachelor degree in Civil Engineering/Technology or equivalent or a Master degree in Science/MDU Entrance examination recognized Board/ University/ MDU Entrance Examination</p>
//                     </div>
//                     </div>

//             {/* table */}
//             <div className="flex flex-col">
//                 <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
//                     <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
//                     <div className="overflow-hidden">
//                         <table className="min-w-full text-center text-sm font-light">
//                         <thead
//                             className="border-b bg-[#23376c] font-medium text-white rounded-md ">
//                             <tr>
//                             <th scope="col" className=" px-6 py-4">Programme</th>
//                             <th scope="col" className=" px-6 py-4">Branch/ Specialization</th>
//                             <th scope="col" className=" px-6 py-4">Duration (Years)</th>
//                             <th scope="col" className=" px-6 py-4">No. of Seats</th>
//                             <th scope="col" className=" px-6 py-4">One time Charges including Registration</th>
//                             <th scope="col" className=" px-6 py-4">Yearly Fee (All India Quota)</th>
//                             <th scope="col" className=" px-6 py-4">Yearly Fee (UK Domicile)</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 font-semibold ">Master of Technology (M.Tech.)</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Transportation Engineering</td>
//                             <td className="whitespace-nowrap  px-6 py-4">2</td>
//                             <td className="whitespace-nowrap  px-6 py-4">20</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Rs.16000/-</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Rs.100000/-</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Rs.75000/-</td>
//                             </tr>
//                         </tbody>
//                         </table>
//                     </div>
//                     </div>
//                 </div>
//                 </div>

//                 <div className="flex flex-col mt-10 mb-5 ">
//                 <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
//                     <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
//                     <div className="overflow-hidden">
//                         <table className="min-w-full text-center text-sm font-light">
//                         <thead
//                             className="border-b bg-[#23376c] font-medium text-white rounded-md ">
//                             <tr>
//                             <th></th>
//                             <th scope="col" className=" px-6 py-4">SCHOLARSHIP PROGRAMS (Only One will be applicable)</th>
//                             <th></th>
//                             <th></th>
//                             <th></th>
//                             </tr>
//                             <tr>
//                             <th scope="col" className=" px-6 py-4">Sr. No</th>
//                             <th scope="col" className=" px-6 py-4">Particulars</th>
//                             <th scope="col" className=" px-6 py-4">Category</th>
//                             <th>Percentage</th>
//                             <th>Applicable</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">1</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Single Girl Child</td>
//                             <td></td>
//                             <td className="whitespace-nowrap  px-6 py-4">10%</td>
//                             <td>All Years</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 " >2</td>
//                             <td className="whitespace-nowrap  px-6 py-4" rowSpan={4}>Merit Based</td>
//                             <td>75%-80%</td>
//                             <td className="whitespace-nowrap  px-6 py-4">20%</td>
//                             <td>*</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">3</td>
//                             <td className="whitespace-nowrap  px-6 py-4">80%-90%</td>
//                             <td className="whitespace-nowrap  px-6 py-4">30%</td>
//                             <td>*</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">4</td>
//                             <td className="whitespace-nowrap  px-6 py-4">90%-95%</td>
//                             <td className="whitespace-nowrap  px-6 py-4">50%</td>
//                             <td>*</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">5</td>
//                             <td className="whitespace-nowrap  px-6 py-4">95%-100%</td>
//                             <td className="whitespace-nowrap  px-6 py-4">70%</td>
//                             <td>*</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">6</td>
//                             <td className="whitespace-nowrap  px-6 py-4">For Hill States (J&K, Ladakh, Assam, Arunachal Pradesh, Manipur, <br/>Mizoram, Meghalaya, Sikkim, Tripura, HP, Darjeeling, Kalimpong (West Bengal))</td>
//                             <td></td>
//                             <td className="whitespace-nowrap  px-6 py-4">15%</td>
//                             <td>All Years</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">7</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Martyrs/Defence Scholarship</td>
//                             <td></td>
//                             <td className="whitespace-nowrap  px-6 py-4">20%</td>
//                             <td>All Years</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 " >8</td>
//                             <td className="whitespace-nowrap  px-6 py-4" rowSpan={3}>Sport Quota Scholarship</td>
//                             <td>State</td>
//                             <td className="whitespace-nowrap  px-6 py-4">25%</td>
//                             <td>All Years</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 " >9</td>
//                             <td>National</td>
//                             <td className="whitespace-nowrap  px-6 py-4">35%</td>
//                             <td>All Years</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 " >10</td>
//                             <td>International</td>
//                             <td className="whitespace-nowrap  px-6 py-4">50%</td>
//                             <td>All Years</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">11</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Disabled Student Scholarship</td>
//                             <td></td>
//                             <td className="whitespace-nowrap  px-6 py-4">40%</td>
//                             <td>All Years</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">12</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Siblings Scholarship</td>
//                             <td></td>
//                             <td className="whitespace-nowrap  px-6 py-4">25%</td>
//                             <td>**</td>
//                             </tr>
//                             <tr className="border-b dark:border-neutral-500">
//                             <td className="whitespace-nowrap  px-6 py-4 ">13</td>
//                             <td className="whitespace-nowrap  px-6 py-4">Early Bird till 8th June</td>
//                             <td></td>
//                             <td className="whitespace-nowrap  px-6 py-4">40%</td>
//                             <td>*</td>
//                             </tr>

//                         </tbody>
//                         </table>
//                     </div>
//                     </div>
//                 </div>
//                 </div>

//             <div className=' flex flex-col gap-10 mt-5 mb-[50px] ' >
//                <div className=' flex flex-col gap-2 items-center justify-center px-10 py-8 rounded-lg bg-[#23376c] ' >
//                         <h4 className={` text-2xl font-semibold text-[#0e4d38] `}>Note</h4>
//                         <p className=' text-white italic font-semibold ' > * From 2nd year scholarship will be offered only on 75% attendance in previous year with no back paper and no misconduct.</p>
//                         <p className=' text-white font-semibold italic ' > ** applicable on those courses whose fees will be less compared to other siblings.</p>
//                     </div>
//             </div>


//         </div>
//         <Footer/>
//     </div>
//   )
// }

// export default MtechTransportation




import React from 'react';
import Footer from '../../../../components/Footer';
import BtechImg from "../../../../assets/images/engineering.jpeg"; // Update with a relevant cyber security image
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
    Shield,
    GraduationCap,
    Lock,
    Target,
    BookOpen,
    FlaskConical,
    MapPin,
    Users,
    Code,
} from 'lucide-react';
import Title from '../../../../components/TitleComponent';

const MtechTransportation = () => {
    const fadeIn = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.6 }
    };

    return (
        <div className='w-full relative font-poppins'>
            <Title canonicalPath="/programmes/pg-courses/engineering/mtech/transportation-engineering
" />
            <Title title="M.Tech in Transportation Engineering at Top Colleges
" description="Pursue M.Tech in Transportation Engineering from leading Indian institutes. Develop expertise in traffic management, transportation planning, & infrastructure design.
" />
            {/* Hero Section */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className='relative h-[300px] md:h-[400px] bg-[#0e4d38] mt-[60px] md:mt-[80px] overflow-hidden'
            >
                <div className='absolute inset-0 bg-black/50'></div>
                <div className='relative z-10 h-full flex flex-col justify-center items-center text-white px-4'>
                    <h1 className='text-3xl md:text-6xl font-bold text-center mb-4'>
                        M.Tech in Transportation Engineering
                    </h1>
                </div>
            </motion.div>

            <div className='w-11/12 md:w-10/12 mx-auto mt-8 md:mt-16'>
                {/* About Section */}
                <motion.div
                    {...fadeIn}
                    className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px]'
                >
                    <img src={BtechImg} className='md:w-[40%] rounded-xl shadow-lg' alt="Cyber Security" />
                    <div className='flex flex-col gap-4'>
                        <div className='flex items-center gap-3'>
                            <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                                <Shield size={24} />
                            </div>
                            <h4 className='font-bold text-2xl md:text-3xl text-[#0e4d38]'>Program Overview</h4>
                        </div>
                        <div className='text-justify md:text-lg space-y-4 text-gray-700'>
                            Transportation technology has evolved significantly, from basic, primitive roads to the complex flyovers of today. Transportation Engineering, a specialized branch of Civil Engineering, focuses on the planning, design, maintenance, and development of transport pathways. The institution offers a two-year Master's degree in Transportation Engineering that provides students with both the scientific and technical expertise needed for the functional design, operation, and management of various transportation systems. Through a combination of coursework, site visits, and expert lectures, students gain the necessary skills to ensure the safe, efficient, and seamless movement of people and goods. With guidance from experienced faculty, many of whom come from prestigious institutions, students develop both critical technical knowledge and essential industry skills. Graduating from this program equips students with the competencies to explore a wide range of career opportunities in the transportation sector.

                        </div>
                        <Link to="https://admission.maya.edu.in/">
                            <motion.button
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                className='mt-5 md:mt-4 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2'
                            >
                                <GraduationCap size={20} />
                                Apply Now
                            </motion.button>
                        </Link>
                    </div>
                </motion.div>

                {/* Learning Outcomes */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Target size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Learning Outcomes</h4>
                    </div>
                    <p className='text-gray-700 leading-relaxed mb-4'>
                        Transportation Engineering encompasses a broad range of areas, including road safety, land use planning, sustainable transport, transportation facility planning and design, and traffic engineering, among others. Mastery of these topics requires a solid understanding of the processes involved in planning, evaluating, designing, constructing, and maintaining transportation infrastructure. Upon completing this program, students can take up careers in various fields such as:
                    </p>
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "•	Road Safety Engineer ",
                            "•	Transit Systems Engineer ",
                            "•	Traffic Operations Analyst",
                            "•	Pavement Design Engineer ",
                            "•	Public Transport Systems Analyst ",
                            "•	Railway Engineer ",
                        ].map((role, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{role}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Laboratories and Facilities */}
                <motion.div {...fadeIn} className='mb-12 bg-white p-6 rounded-xl shadow-lg'>
                    <div className='flex items-center gap-3 mb-6'>
                        <div className='p-2 rounded-lg bg-[#0e4d38] text-white'>
                            <Code size={24} />
                        </div>
                        <h4 className='font-bold text-2xl text-[#0e4d38]'>Laboratories and Facilities </h4>
                    </div>

                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
                        {[
                            "•	Concrete Technology Lab ",
                            "•	Structural Engineering Lab ",
                            "•	Geotechnical Engineering Lab ",
                        ].map((lab, index) => (
                            <motion.div
                                key={index}
                                whileHover={{ scale: 1.02 }}
                                className='p-4 bg-gray-50 rounded-lg border border-gray-200'
                            >
                                <p className='text-gray-700 font-medium'>{lab}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Admission Requirements */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="bg-white p-6 rounded-xl shadow-lg mb-12"
                >
                    <div className="flex items-center gap-3 mb-6">
                        <div className="p-2 rounded-lg bg-[#0e4d38] text-white">
                            <GraduationCap size={24} />
                        </div>
                        <h4 className="font-bold text-2xl text-[#0e4d38]">Admission Requirements</h4>
                    </div>

                    <div className="space-y-4">
                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Duration of the Program:</span> 2 Years (Semester System)
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Affiliation:</span> Constituent College of Maya Devi University
                            </p>
                        </div>

                        <div className="flex items-start gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full mt-2"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Eligibility Criteria:</span> Candidate shall have passed BE/B.Tech or equivalent examination in relevant discipline with minimum 55% for Open Category (45% for SC/ST/OBC Candidates), and have qualified GATE or MDU entrance examination, followed by an interview. • Mode of Admission – As per university procedure
                            </p>
                        </div>

                        <div className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg">
                            <div className="w-2 h-2 bg-[#23376c] rounded-full"></div>
                            <p className="text-gray-700">
                                <span className="font-semibold">Mode of Admission:</span> As per university procedure
                            </p>
                        </div>
                    </div>
                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default MtechTransportation;
